
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import appCode from "@common/src/utils/app-code";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { InjectFunction } from "@common/src/utils/decorator";
import CustomerFlag from "@common/src/components/scope/customer-flag/index.vue";
import PrintDropdown from "./components/print-dropdown.vue";
const base = namespace("base");
const staff = namespace("staff");
const testingItem = namespace("testing-item");
const setting = namespace("setting");
const management = namespace("management");
@InjectFunction("dayjs", "permitApp", "appCode")
@Component({
  components: { CustomerFlag, PrintDropdown }
})
@Table("loadListData")
export default class ServiceList extends Vue {
  dayjs = dayjs;
  @testingItem.Action getTestOrdeList;
  @testingItem.Action getTestingTemplateList;
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @setting.Getter isOpenDispatch;
  emptyToLine = emptyToLine;
  @management.Action getStoreList;
  splitThousands = splitThousands;
  orderList: any[] = [];
  showPickingTips: boolean = false;
  searchForm = {
    orderTimeEnd: "",
    orderTimeStart: "",
    orderStatus: "",
    technicianCode: "",
    searchKey: "",
    templateCode: "",
    storeCode: ""
  };
  orderStatus: any = "";
  testTemplateList: any[] = [];
  orderSourceList: any[] = [];

  created() {
    this.loadListData();
    this.init();
  }
  init() {
    // 订单状态字典List
    this.getDictionaryList("check_order_status").then(data => {
      this.orderStatus = data;
    });
    // 模板列表
    if (appCode === "speedbiz") {
      this.getTestingTemplateList({
        pageNum: this.mix_pageNum,
        pageSize: 999
      }).then(data => {
        this.testTemplateList = data.data.list.map(item => ({
          label: item.checkTemplateName,
          value: item.checkTemplateCode
        }));
      });
      // 员工和顾问 List
      this.getStaffList({
        pageSize: 999,
        pageNum: 1
      }).then(data => {
        const staffList = this.$safeValue(data, "data.list", []).map(item => ({
          label: item.staffName,
          value: item.userCode
        }));
        this.staffList = staffList;
      });
    } else {
      // this.searchStore();
    }
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getTestOrdeList({
      ...this.searchForm,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      return data;
    });
  }
  invoicingList: any[] = [];
  staffList: any[] = [];
  get searchList() {
    if (this.appCode === "speedbiz") {
      return [
        {
          label: t("test.keyword"),
          type: "input",
          value: "",
          prop: "searchKey",
          placeholder: t("test.license-name-mobile-vincode")
        },
        {
          label: t("finance.creation-time"),
          type: "daterange",
          value: "",
          prop: "createDate"
        },
        {
          label: t("test.detection-template"),
          type: "select",
          selectList: this.testTemplateList,
          value: "",
          prop: "templateCode"
        },
        {
          label: t("test.service-consultant"),
          type: "select",
          selectList: this.staffList,
          value: "",
          prop: "advisorCode"
        },
        {
          label: t("test.service-technician"),
          type: "select",
          selectList: this.staffList,
          value: "",
          prop: "technicianCode"
        },
        {
          label: t("v213.Status"),
          type: "select",
          selectList: this.orderStatus,
          value: "",
          prop: "orderStatus"
        }
      ];
    } else if (this.appCode === "speedbiz-operation") {
      return [
        {
          label: t("v210831.store-name"),
          type: "select-search",
          value: "",
          prop: "storeCode",
          placeholder: t("v210801.please-enter-keyword"),
          selectList: this.storeList,
          searchFun: this.searchStore
        },
        {
          label: t("test.keyword"),
          type: "input",
          value: "",
          prop: "searchKey",
          placeholder: t("test.license-name-mobile-vincode")
        },

        {
          label: t("v213.Status"),
          type: "select",
          selectList: this.orderStatus,
          value: "",
          prop: "orderStatus"
        },
        {
          label: t("finance.creation-time"),
          type: "daterange",
          value: "",
          prop: "createDate"
        }
      ];
    } else {
      return [];
    }
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "createDate") {
          if (item.value) {
            this.searchForm["orderTimeStart"] = item.value[0];
            this.searchForm["orderTimeEnd"] = item.value[1];
          } else {
            this.searchForm["orderTimeStart"] = "";
            this.searchForm["orderTimeEnd"] = "";
          }
        } else if (item.prop === "orderStatus") {
          this.searchForm[item.prop] = item.value ? item.value : "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  handleLinkCommand(url) {
    this.$router.push(url);
  }
  showOrderVaildCode: boolean = false; // 提否显示核销弹窗

  handleEdit(row) {
    this.$router.push(`/test/edit/${row.checkOrderNo}`);
  }

  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/test/view/${row.checkOrderNo}`
    });
    window.open(href, "_blank");
  }
  handleDispatch() {
    let { href } = this.$router.resolve({
      path: `/service/dispatch-worker/index`
    });
    window.open(href, "_blank");
  }
  storeList: any = [];
  searchStore(val = "") {
    this.getStoreList({
      pageNum: 1,
      pageSize: 10,
      storeName: val
    }).then(data => {
      this.storeList = data.data.list
        ? data.data.list.map(item => {
            item.label = item.storeName;
            item.value = item.storeCode;
            return item;
          })
        : [];
    });
  }
}
